import { useEffect } from 'react';
import { Breadcrumbs } from 'AbstractElements';
import DetailSubMateriContain from 'Component/Learning/DetailSubMateri';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setDetail } from 'Features/Learning/SubMateri/subMaterialSlice';
import { fetchSubMaterial } from 'Features/Learning/SubMateri/Utils/SubMateriUtils';
import { handleGetDetailSubMaterial } from 'Component/Learning/SubMateri/SubMateriUtils';

const DetailSubMateri = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  // const detail = useSelector(state => state.subMaterial.detail)
  const filters = useSelector(state => state.subMaterial.filters)

  useEffect(() => {
    if (id) {
      const newFilters = {
        ...filters,
        "filter[id]": id,
        "page": 1,
      };
      dispatch(fetchSubMaterial(newFilters))
        .then((response) => {
          // Kode yang akan dijalankan setelah fetch sukses
          handleGetDetailSubMaterial(dispatch, response.payload.data[0], setDetail)
        })
        .catch((error) => {
          // Tangani error jika fetch gagal
          console.error('Error during fetchSubMaterial:', error);
        });
    }
  }, [id]);

  return (
    <>
      <Breadcrumbs mainTitle="Detail Submateri" parent="Learning" title="Detail Submateri" />
      <DetailSubMateriContain />
    </>
  );
};
export default DetailSubMateri;